import { Reducer } from "redux"
import { DataAPIType, AuthUserType } from "../../../Actions/Types"
import { APIDataModel } from "../../../Models/API/DataModel"
import { UserAction } from "../../Auth/UserReducer"
import { SortExpression } from "../../../Models/Client/SortExpression"
import { FetchState } from "../../../Models/Client/FetchState"

export interface DataState {
    signedUrls: {
        [path: string]: FetchState<string>
    }
    list: APIDataModel[]
    loading: boolean
    pageSize: number
    pageNumber: number
    pages: number
    totalItemCount: number
    sort: SortExpression<APIDataModel>
}

interface DataReceiveSignalUrlAction {
    type: DataAPIType.signedUrlRequestStateChanged
    meta: {
        path: string
    }
    payload: FetchState<string>
}

interface DataRequestListAction {
    type: DataAPIType.requestList
}

interface DataReceiveListAction {
    type: DataAPIType.receivedList
    payload: {
        list: APIDataModel[]
        pageNumber: number
        totalItemCount: number
        pages: number
        sort: SortExpression<APIDataModel>
    }
}

export type DataAction =
    | DataReceiveSignalUrlAction
    | DataRequestListAction
    | DataReceiveListAction

const initialState: DataState = {
    signedUrls: {},
    list: [],
    loading: false,
    pageSize: 30,
    pageNumber: 0,
    totalItemCount: 0,
    pages: 1,
    sort: { sortBy: "created", desc: true }
}

export const DataReducer: Reducer<DataState, DataAction | UserAction> = (
    state = initialState,
    action
): DataState => {
    switch (action.type) {
        case DataAPIType.signedUrlRequestStateChanged:
            return {
                ...state,
                signedUrls: {
                    ...state.signedUrls,
                    [action.meta.path]: action.payload
                }
            }
        case DataAPIType.requestList:
            return {
                ...state,
                loading: true
            }
        case DataAPIType.receivedList:
            const { list, pages, pageNumber, sort, totalItemCount } =
                action.payload

            return {
                ...state,
                loading: false,
                totalItemCount,
                list,
                pages,
                pageNumber,
                sort
            }
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
